export default function StoresColumn(props) {
    return (
        <div style={{ height: '100%', padding: 5,  width: '16.66666666666666%', overflowY: 'auto', display: 'inline-block' }}>
            {props.children}
        </div>
    )
}